import { match } from "ts-pattern";

export const convertGroupName = (name: string) => {
	return match(name)
		.with("Owner", () => "Manager:In")
		.with("Editor", () => "Redakteur:In")
		.with("User", () => "Benutzer:In")
		.otherwise(() => name);
};
